import { useQuery } from 'react-query';
import { AppConfig, FhirServiceRequest, urlUtils } from '@oh-vcp/components-common';
import { apiGet } from './apiService';
import type { AxiosRequestConfig } from 'axios';

const fetchSmartOnFhirData = async (
  resourceType: string,
  id: string | undefined
): Promise<FhirServiceRequest> => {
  return apiGet(`${AppConfig.baseSofLaunchUrl}/fhir/${resourceType}/${id}`, undefined, {
    headers: { Accept: 'application/fhir+json' }
  } as AxiosRequestConfig);
};

const useSmartOnFhirResource = (resourceType: string, id: string | undefined) => {
  return useQuery({
    enabled: !!id,
    refetchOnWindowFocus: false,
    retry: 0,
    queryFn: () => fetchSmartOnFhirData(resourceType, id),
    queryKey: ['useSmartOnFhirResource', resourceType, id]
  });
};

export { fetchSmartOnFhirData };
export default useSmartOnFhirResource;
